import logo from "./logo.svg";
import "./App.css";

function App() {
  return (
    <div className="App">
      <h1>Future site of the life and times of Hasel, a Cessna 150</h1>
    </div>
  );
}

export default App;
